import dynamic from 'next/dynamic';

const HeadC = dynamic(() => import('src/components/Head'));
const ContactContainer = dynamic(() => import('src/containers/Contact'));

const Contacts = () => {
	return (
		<>
			<HeadC
				title="Hubungi Kami - Layanan Bantuan & Dukungan untuk Mama "
				description={
					'Butuh bantuan atau ingin memberi masukan? Hubungi tim HalloBumil' +
					' untuk pertanyaan seputar kehamilan, parenting, atau aplikasi kami.' +
					' Kami siap membantu Mama!'
				}
			/>
			<ContactContainer />
		</>
	);
};

export default Contacts;
